import { Modal, ModalDialog, DialogContent, DialogTitle, FormControl, FormLabel, Input, Grid, Drawer, ModalClose, Divider, Checkbox, DialogActions, Button, Box, Textarea, Autocomplete, Typography } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { InspectionReport } from "../Pages/InspectionReportsListing";
import { Elevator } from "../Interfaces/Elevator";
import { DatePicker } from "@mui/x-date-pickers";

interface InspectionReportDialogProps {
	inspectionReport: InspectionReport;
	close: Function;
	elevators: Array<Elevator>;
	open: boolean;
	buildingId: string;
}

export default function InspectionReportDialog(props: InspectionReportDialogProps) {
	const uploadRef = React.useRef<HTMLInputElement>(null);
	const [description, setDescription] = React.useState("");
	const [date, setDate] = React.useState<Date | null>(null);
	const [fileName, setFileName] = React.useState("");
	const [elevator, setElevator] = React.useState<Elevator | null>(null);
	React.useEffect(() => {
		setDescription(props.inspectionReport.description);
		setDate(props.inspectionReport.date_entered ? new Date(props.inspectionReport.date_entered) : null);
		setFileName(props.inspectionReport.file_name);
		setElevator(props.elevators.find((x) => x.elevators_id === props.inspectionReport.elevators_id) ?? null);
	}, [props.open]);
	const save = () => {
		const ref = uploadRef.current;
		const fd = new FormData();
		if (ref && ref.files) {
			const file = ref.files[0];
			fd.append("file", file);
		}

		fd.append("bldg", props.buildingId);
		if (elevator) fd.append("elevator", elevator.elevators_id);

		date && fd.append("inspectionDate", Util.Formatter(date, "D") as string);
		description && fd.append("description", description);

		if (props.inspectionReport && props.inspectionReport.inspection_reports_id) {
			fd.append("inspectionsId", props.inspectionReport.inspection_reports_id);
		}

		fetch("Inspection/SaveInspection", {
			method: "POST",
			body: fd,
		}).then(close);
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
	};
	const setFile = () => {
		if (uploadRef.current && uploadRef.current.files && uploadRef.current.files.length > 0) setFileName(uploadRef.current.files[0].name);
	};

	const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
		event.preventDefault();
		const files = event.dataTransfer.files;
		if (files.length > 0) {
			setFileName(files[0].name);
			if (uploadRef.current) {
				const dataTransfer = new DataTransfer();
				dataTransfer.items.add(files[0]);
				// Assign the new FileList to the input
				uploadRef.current.files = dataTransfer.files;
			}
		}
	};
	return (
		<>
			<Drawer anchor="right" open={props.open} size="md">
				<ModalClose onClick={() => close()} />
				<DialogTitle>Inspection Report</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
						<Grid {...threeSizes}>
							<Button sx={{ width: "100%", mt: 3 }} onClick={() => uploadRef.current && uploadRef.current.click()}>
								Select File
							</Button>
							<input ref={uploadRef} onChange={setFile} style={{ display: "none" }} type="file" />
						</Grid>

						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>File Name</FormLabel>
								<Input value={fileName} disabled title={fileName}></Input>
							</FormControl>
						</Grid>

						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Description</FormLabel>
								<Input value={description} onChange={(event) => setDescription(event.target.value)}></Input>
							</FormControl>
						</Grid>

						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Inspection Date</FormLabel>
								<DatePicker
									slotProps={{
										textField: { variant: "standard", size: "small" },
									}}
									value={date}
									format="MM/dd/yyyy"
									onChange={(value) => {
										setDate(value as Date);
									}}
								/>
							</FormControl>
						</Grid>

						<Grid {...threeSizes}>
							<FormControl>
								<FormLabel>Elevator</FormLabel>
								<Autocomplete
									options={props.elevators}
									getOptionLabel={(opt: Elevator) => opt.serial_number}
									openOnFocus
									value={props.elevators.find((x) => x.elevators_id === elevator?.elevators_id) || null}
									onChange={(event, value) => {
										setElevator(value);
									}}
								/>
							</FormControl>
						</Grid>
						<Grid xs={12} onDrop={handleDrop} onDragEnter={(event) => event.preventDefault()} onDragOver={(event) => event.preventDefault()} sx={{ border: "3px dashed #ebebeb", height: "80px", backgroundColor: "#f2f2f2", borderRadius: "16px", alignContent: "center", textAlign: "center" }}>
							<Typography typography="h2">Drop File</Typography>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
